module.exports = __webpack_public_path__ + "static/media/symptom_management.e0122cfd.png";